export let userAgent: string | undefined;

export const setUserAgent = (agent?: string): void => {
	if (agent) {
		userAgent = agent;
	} else if (typeof window !== 'undefined' && window.navigator) {
		userAgent = window.navigator.userAgent;
	}
};

export const reset = (): void => {
	userAgent = undefined;
};

export const isFirefox = (): boolean => {
	return userAgent?.indexOf('Firefox/') !== -1;
};

export const notFirefox = (): boolean => {
	return !isFirefox();
};

export const isMSEdge = (): boolean => {
	return userAgent?.indexOf('Edge/') !== -1;
};

export const notMSEdge = (): boolean => {
	return !isMSEdge();
};

export const isIE = (): boolean => {
	return userAgent?.indexOf('MSIE') !== -1 || userAgent?.indexOf('Trident/') !== -1 || isMSEdge();
};

export const notIE = (): boolean => {
	return !isIE();
};

export const isChrome = (): boolean => {
	return userAgent?.indexOf('Chrome/') !== -1;
};

export const notChrome = (): boolean => {
	return !isChrome();
};

export const isSafari = (): boolean => {
	return userAgent?.indexOf('Safari/') !== -1 && userAgent?.indexOf('Chrome/') === -1;
};

export const notSafari = (): boolean => {
	return !isSafari();
};

export const isPhantom = (): boolean => {
	return userAgent?.indexOf('PhantomJS') !== -1;
};

export const notPhantom = (): boolean => {
	return !isPhantom();
};

export const isNativeMobile = (): boolean => {
	return (
		!!userAgent &&
		(userAgent?.indexOf('Confluence iOS/') !== -1 ||
			userAgent?.indexOf('Confluence Android/') !== -1)
	);
};

export const version = (): number | null | undefined => {
	let versionMatch: RegExpMatchArray | null | undefined;

	if (isIE()) {
		versionMatch =
			userAgent?.match(/MSIE\s([\d.]+)/) ||
			userAgent?.match(/rv:([\d.]+)/) ||
			userAgent?.match(/Edge\/([\d.]+)/);
	} else if (isChrome()) {
		versionMatch = userAgent?.match(/Chrome\/([\d.]+)/);
	} else if (isSafari()) {
		versionMatch = userAgent?.match(/Version\/([\d.]+)/);
	} else if (isFirefox()) {
		versionMatch = userAgent?.match(/Firefox\/([\d.]+)/);
	}

	return versionMatch && parseInt(versionMatch[1]);
};

export const friendlyName = (): 'MSEdge' | 'IE' | 'Chrome' | 'Safari' | 'Firefox' | undefined => {
	if (isMSEdge()) {
		return 'MSEdge';
	}
	if (isIE()) {
		return 'IE';
	}
	if (isChrome()) {
		return 'Chrome';
	}
	if (isSafari()) {
		return 'Safari';
	}
	if (isFirefox()) {
		return 'Firefox';
	}
};
